import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Patient } from '../models';
import { Api, Session } from '../services/index';

@Component({
  selector: 'app-family',
  templateUrl: './dashboard-family.html',
  styleUrls: ['./dashboard-family.css']
})

export class DashboardFamilyComponent implements OnInit {
  //patientDependents: Patient[] = [];
  patientDependents: Array<Patient>;
  dependentsAllowed:boolean = true;
  loading:boolean = false;
  hasDepenents:boolean = false;
  constructor(private api: Api, 
              private route: ActivatedRoute,
              private router: Router,
              private service: NotificationsService,
              private session: Session) { 
  }

  ngOnInit() {    
    this.loading = true;
    this.patientDependents = new Array<Patient>();
    console.log('api.getDependentsAllowed session.patient', this.session.patientId);
    
  
    this.api.getDependentsAllowed(this.session.patientId).subscribe(response =>{
      console.log('api.getDependentsAllowed:', response);
      this.dependentsAllowed = response;
    });


   

    let dependents = this.api.getDependents(this.session.patientId);
    dependents.subscribe(response => {
      this.patientDependents = response;
      for (let i = 0; i < this.patientDependents.length; i++) {        
        if (this.patientDependents[i].avatar) {
          this.patientDependents[i].avatar = this.session.environment.settings.patientAvatarBucket + this.patientDependents[i].avatar;
        } else if (this.patientDependents[i].profile.gender.toUpperCase() == 'F') {
          this.patientDependents[i].avatar = '../../assets/images/patient-avatar-female.png';
        } else {
          this.patientDependents[i].avatar = '../../assets/images/patient-avatar-male.png';
        }
      }
      if(this.patientDependents.length > 0){
        this.hasDepenents = true;
      }
      this.loading = false;
    })
  }
  
  profileTapped(patient) {
    this.router.navigate(['/family-member/' + patient.userId]);
  }

  addFamilyMemberTapped() {
    this.router.navigate(['/family-member']);
  }

  gotoDashboard() {
		this.router.navigate(['/dashboard']);
	}
}
